import { jsPDF } from 'jspdf';

import { TABLE_HEADERS } from './constants';
import LumberLogo from './images/lumber-logo.png';
import useCalculator from './useCalculator';
import { FontOswald } from '../../BuildYourRoof/pdf/fonts/oswald';
import { FontRobotoBold } from '../../BuildYourRoof/pdf/fonts/roboto-bold';
import { FontRobotoRegular } from '../../BuildYourRoof/pdf/fonts/roboto-regular';

const useLumberDeckingPdf = () => {
  const { result } = useCalculator();

  // When user clicks on the "Download PDF" button this method is called
  // It's the exactly reflection of the table shown in the UI
  // The PDF is assembled manually. That's mostly because the table from jsPDF does not look similar to
  // the take off sheet shown in the UI.
  // Also there are some font changing from texts and a footnote section at the end.
  const generatePdf = () => {
    const dataToBeDisplayed = Object.keys(result).map(type => {
      const { size, quantity, length, overage, total } = result[type];
      return [
        type.charAt(0).toUpperCase() + type.slice(1),
        size || '--',
        length || '--',
        quantity || '--',
        overage || '--',
        total || '--',
      ];
    });

    // eslint-disable-next-line
    const doc = new jsPDF({ putOnlyUsedFonts: true, orientation: 'landscape' });

    const startX = 20;

    doc.addImage(LumberLogo, 'JPEG', startX, 10, 44, 14);

    [FontOswald, FontRobotoRegular, FontRobotoBold].forEach(font => {
      doc.addFileToVFS(font.filename, font.data);
      doc.addFont(font.filename, font.family, font.weight);
    });

    doc.setFontSize(20);
    doc.setFont(FontOswald.family);
    doc.text('MATERIAL TAKE OFF SHEET', startX, 40);

    let startY = 45;
    const rowHeight = 12;
    const colWidth = 45;

    doc.setFontSize(11);
    doc.setFont(FontRobotoBold.family);
    // Draw header row
    TABLE_HEADERS.forEach((header, index) => {
      const x = startX + index * colWidth;
      doc.setDrawColor(128, 128, 128);
      doc.setFillColor(248, 248, 248);
      doc.rect(x, startY, colWidth, rowHeight, 'FD'); // Fill + stroke
      doc.setTextColor(0, 0, 0);
      doc.text(header, x + 2, startY + 7);
    });

    startY += rowHeight;

    doc.setFont(FontRobotoRegular.family);
    // Draw data rows
    dataToBeDisplayed.forEach((row, rowIndex) => {
      const isEven = rowIndex % 2 === 0;
      const fillColor = isEven ? [255, 255, 255] : [248, 248, 248]; // Alt background

      row.forEach((cell, colIndex) => {
        const x = startX + colIndex * colWidth;
        doc.setDrawColor(128, 128, 128);
        doc.setFillColor(...fillColor);
        doc.rect(x, startY, colWidth, rowHeight, 'FD'); // Fill + border
        doc.setTextColor(0, 0, 0);
        doc.text(String(cell), x + 2, startY + 7);
      });

      startY += rowHeight;
    });

    doc.setFontSize(10);
    doc.setFont(FontRobotoBold.family);
    doc.text('Footnotes:', 20, startY + 10);
    doc.setFont(FontRobotoRegular.family);
    doc.text(
      [
        ' Overage includes blocking.',
        ' Decking is presumed to be spaced 3/16".',
        ' Overage for decking is 20%.',
        ' Overage for Structural Framing is 15%.',
        '\n',
        " Standard board lengths are 12', 16', 20' & 24'.",
        '\n',
        // eslint-disable-next-line
        ' Depending on the handrail system being used, ensure adequate blocking per handrail manufacturer recommendation or follow AWC DCA-6 for handrail attachment.',
        // eslint-disable-next-line
        ' The material estimates provided by the Material Takeoff are intended for informational purposed only.',
        ' These values are approximations and should not be considered as final or binding.',
        '\n',
        // eslint-disable-next-line
        ' It is the responsibility of the builder to verify all quantities and specifications before placing any orders. Owens Corning assumes',
        ' no liability for any discrepancies or errors in the estimates.',
        ' Use of this estimator is at the user’s own risk.',
      ],
      startX,
      startY + 20
    );

    doc.save('lumber_decking_sheet.pdf');
  };

  return { generatePdf };
};

export default useLumberDeckingPdf;
